import {
  fetchWithAuthHeader,
  buildRequestOptionsJsonBody,
} from '@quintoandar/fwp-fetch';
import { request } from '../utils/request-utils';
import { entryAccessEligibilityListURL, entryAccessURL } from './urls';

export const fetchEntryAccessEligibilityList = (houseId) =>
  request(entryAccessEligibilityListURL(houseId));

export const fetchEntryAccess = (houseId, journey) => {
  const endpoint = entryAccessURL(houseId, journey);
  const options = buildRequestOptionsJsonBody('GET', undefined, {
    'Content-Type': 'application/json',
  });

  return fetchWithAuthHeader(endpoint, options, false);
};
